import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getSanFranciscoStructuredData() {
  const url = "https://restorehair.com/locations/california/san-francisco/";
  const description =
    "Find out about your hair transplant options in San Francisco with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("san-francisco", url, description),
    locationPageCrumbs(url, "San Francisco"),
  ];
}
